import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import { downloadApprovedTotalDevBudgets, downloadMilestoneApprovedBudgetsAndCosts } from '@gp/services/finance';

import type { IRecord } from '@gp/types/global';

export default function useDownloadDevBudgetChange(category: '1' | '2 ' | (string & {})) {
  const { isDownloading: isCategory1Downloading, handleDownload: handleCategory1Download } = useDownload({
    csvDownloadLogKey: '',
    excelDownloadLogKey: 'DETAIL_FINANCE_DEV_BUDGET_CHANGE_APPROVED_TOTAL_DEV_BUDGET_EXCEL_DOWNLOAD_SUBMIT',
    downloadService: createDownloadService(downloadApprovedTotalDevBudgets),
  });

  const { isDownloading: isCategory2Downloading, handleDownload: handleCategory2Download } = useDownload({
    csvDownloadLogKey: '',
    excelDownloadLogKey: 'DETAIL_FINANCE_DEV_BUDGET_CHANGE_MILESTONE_APPROVED_BUDGET_COST_EXCEL_DOWNLOAD_SUBMIT',
    downloadService: createDownloadService(downloadMilestoneApprovedBudgetsAndCosts),
  });

  const isDownloadings: IRecord<boolean> = {
    '1': isCategory1Downloading,
    '2': isCategory2Downloading,
  };

  const handleDownloads: IRecord<(params: any) => Promise<void>> = {
    '1': handleCategory1Download,
    '2': handleCategory2Download,
  };

  return {
    isDownloading: isDownloadings[category] ?? false,
    handleDownload: handleDownloads[category] ?? (() => {}),
  };
}
